import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getProblemsBySlug,
  getJupyerPodStatusbySolutionSlug,
  createJupyterPodbyProblemSlug,
  checkPodHealth as podHealthCheck,
} from '../api/test';
import ActionTypes from '../constants/ActionTypes';
import { errorLogger } from '../utils/trackingUtil';
import { POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS } from '../components/ProblemTypes/PodBasedSolution/constants';
import { NETWORK_ERROR } from '../constants/Http';
import { showErrorToast } from '../actions/toast';
import { POD_BASED_CREATE_SERVER_ERROR_MSG } from '../constants/Constants';

function* fetchProblemBySlug(args) {
  try {
    const res = yield call(getProblemsBySlug, args.payload);

    yield put({
      type: `${ActionTypes.GET_PROBLEM_BY_SLUG}_SUCCESS`,
      payload: { data: res.data, problemSlug: args.payload.problemslug },
    });
  } catch (err) {
    errorLogger(err);
  }
}

function* checkPodHealth(args) {
  const {
    healthCheckInterval,
    healthCheckErrorCount,
    networkErrorCount,
    metaInfo,
  } = yield select(state => state.playGround);
  const errorUpdate = {
    interval: healthCheckInterval,
    count: healthCheckErrorCount,
    networkCount: networkErrorCount,
  };
  try {
    yield call(podHealthCheck, args.healthCheckUrl);
    if (healthCheckInterval !== POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS) {
      errorUpdate.interval = POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS;
      errorUpdate.count = 0;
    }
    yield put({
      type: `${ActionTypes.POD_HEALTH_CHECK}_ERROR_UPDATE`,
      payload: { ...errorUpdate },
    });
  } catch (error) {
    errorLogger(error);
    if (error.message === NETWORK_ERROR) {
      errorUpdate.networkCount = +networkErrorCount + 1;
      errorUpdate.interval = 5 * 1000;
      errorUpdate.count = 0;
      if (errorUpdate.networkCount >= 3 && metaInfo?.resourceSolutionSlug) {
        try {
          const res = yield call(
            getJupyerPodStatusbySolutionSlug,
            metaInfo?.resourceSolutionSlug
          );
          if (
            !res?.data?.project_based_problem_data?.is_ready ||
            res?.data?.project_based_problem_data
              ?.jupyter_notebook_access_url !==
              metaInfo?.data?.project_based_problem_data
                ?.jupyter_notebook_access_url
          ) {
            window.location.replace(args.multiSessionRedirectionUrl);
          }
        } catch (err) {
          // logic
          errorUpdate.interval = POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS;
          errorUpdate.networkCount = 0;
        }
      }
    } else if (error.response) {
      const { response } = error;
      if (response.status === httpStatusCodes.NOT_FOUND) {
        errorUpdate.count = +healthCheckErrorCount + 1;
        errorUpdate.interval = 5 * 1000;
        errorUpdate.networkCount = 0;
      } else if (
        healthCheckInterval !== POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS
      ) {
        errorUpdate.interval = POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS;
        errorUpdate.count = 0;
        errorUpdate.networkCount = 0;
      }

      if (errorUpdate.count >= 3) {
        window.location.replace(args.multiSessionRedirectionUrl);
      }
    }
    yield put({
      type: `${ActionTypes.POD_HEALTH_CHECK}_ERROR_UPDATE`,
      payload: { ...errorUpdate },
    });
  }
}

function* getServerStatus(args) {
  try {
    const res = yield call(getJupyerPodStatusbySolutionSlug, args.payload);
    yield put({
      type: `${ActionTypes.GET_SERVER_STATUS}_SUCCESS`,
      payload: { data: res.data },
    });
  } catch (err) {
    errorLogger(err);
  }
}
function* initJupyterEnv(args) {
  try {
    const res = yield call(createJupyterPodbyProblemSlug, args.payload);
    yield put({
      type: ActionTypes.SET_JUPYTER_ENV_DATA,
      payload: { data: res.data },
    });
  } catch (err) {
    if (err.response?.status === 422) {
      yield put(
        showErrorToast(POD_BASED_CREATE_SERVER_ERROR_MSG, {
          delay: true,
          message: POD_BASED_CREATE_SERVER_ERROR_MSG,
        })
      );
    }
    errorLogger(err);
  }
}

export default function* playgroundSaga() {
  yield takeEvery(ActionTypes.GET_PROBLEM_BY_SLUG, fetchProblemBySlug);
  yield takeEvery(`${ActionTypes.GET_SERVER_STATUS}_JUPYTER`, getServerStatus);
  yield takeEvery(ActionTypes.SETUP_JUPYTER_ENV_PLAYGROUND, initJupyterEnv);
  yield takeEvery(ActionTypes.POD_HEALTH_CHECK, checkPodHealth);
}
